import Table from './table';
import NumericInput from './numericInput';
import './style'
Table.NumericInput = NumericInput
export default Table;
